module.exports = __webpack_public_path__ + "employees-21b62107/super-ellipse-mask-cd22c3b8c137c9902b90787d046b531a.svg";